import * as React from "react";
import { Loader } from "@grandvisionhq/common";
import { useRenderQrForm } from "../../../../hooks/hooks/use-render-qr-form.js";
import { useGetPaymentMethodList } from "../../hooks/modules/PaymentMethodsList/hooks/use-get-payment-method-list.js";
import { PaymentMethodsUI } from "./PaymentMethodsUI.js";
import { PaymentFlow } from "../../../../models/payment/models/payment/types.js";
import { paymentMethodWithForm } from "../../Payments/modules/PaymentMethodsList/Payments/providers.js";
import { usePaymentsUIContext } from "../../../../context/PaymentsUI/context/PaymentsUI/context.js";
import { useAdyen } from "../../../../context/Adyen/context/Adyen/context.js";
const PaymentMethodsUIContainer = ({
  paymentMethodName,
  onPaymentMethodSelected,
  onHandlePayment,
  cartId,
  qrCodeForm,
  isOrderInProgress,
  selectedDonation,
  onDonationSelected,
  totalPrice,
  googlePayActions
}) => {
  const [selectedPaymentMethod, setSelectedPaymentMethod] = React.useState("");
  const { setIsProcessingOrder, setSelectedPaymentMethodPrice } = usePaymentsUIContext();
  const [renderQrForm] = useRenderQrForm();
  const { updatePspInfo } = useAdyen();
  React.useEffect(() => {
    setIsProcessingOrder(isOrderInProgress);
  }, [isOrderInProgress]);
  const handleQrRefresh = React.useCallback(() => {
    onHandlePayment({
      type: selectedPaymentMethod,
      isValid: true,
      data: {}
    });
  }, [onHandlePayment, selectedPaymentMethod]);
  const qrComponent = React.useMemo(() => {
    return qrCodeForm.orderToken && qrCodeForm.qrPaymentConfig && qrCodeForm.paymentFlow === PaymentFlow.QR_CODE ? renderQrForm({
      ...qrCodeForm,
      handleRefreshQrCode: handleQrRefresh,
      cart: cartId ? { id: cartId } : null
    }) : null;
  }, [handleQrRefresh, qrCodeForm, renderQrForm, cartId]);
  const isPaymentActionValid = React.useCallback(
    (paymentConfig) => {
      if (!paymentConfig) {
        return paymentMethodWithForm(selectedPaymentMethod) ? false : true;
      } else {
        return Boolean(paymentConfig?.isValid);
      }
    },
    [selectedPaymentMethod]
  );
  const onPaymentAction = React.useCallback(
    (paymentConfig) => {
      const { additionalCosts, emulatedTotalCartPrice } = paymentMethods.find((method) => method.name === selectedPaymentMethod)?.paymentMethodPrice ?? {};
      const paymentMethodPrice = additionalCosts !== void 0 && emulatedTotalCartPrice !== void 0 ? {
        additionalCosts,
        emulatedTotalCartPrice
      } : void 0;
      onHandlePayment({
        ...paymentConfig,
        isValid: isPaymentActionValid(paymentConfig),
        type: selectedPaymentMethod,
        data: paymentMethodPrice ? {
          ...paymentConfig?.data,
          paymentMethodPrice
        } : paymentConfig?.data
      });
    },
    [onHandlePayment, selectedPaymentMethod, isPaymentActionValid]
  );
  const [paymentMethodItems, _, resetPaymentDetails, { loading, data: paymentMethods }] = useGetPaymentMethodList(
    cartId,
    onPaymentAction,
    selectedDonation,
    onDonationSelected,
    totalPrice,
    googlePayActions
  );
  const handleChange = React.useCallback(
    (selectedPaymentMethodType) => {
      const selectedPaymentMethodConfig = paymentMethods.filter(
        (item) => item.name == selectedPaymentMethodType
      )[0];
      const configuration = selectedPaymentMethodConfig && "configuration" in selectedPaymentMethodConfig ? selectedPaymentMethodConfig.configuration : void 0;
      updatePspInfo && configuration && updatePspInfo({
        merchantId: configuration.merchantId,
        merchantName: configuration.merchantName,
        gatewayMerchantId: configuration.gatewayMerchantId
      });
      selectedPaymentMethodConfig && onPaymentMethodSelected({
        type: selectedPaymentMethodConfig.name,
        provider: selectedPaymentMethodConfig.provider,
        config: selectedPaymentMethodConfig.donations ? {
          name: selectedPaymentMethodConfig.name,
          provider: selectedPaymentMethodConfig.provider,
          donations: selectedPaymentMethodConfig.donations,
          brands: "brands" in selectedPaymentMethodConfig ? selectedPaymentMethodConfig.brands : []
        } : void 0
      });
      setSelectedPaymentMethodPrice(selectedPaymentMethodConfig?.paymentMethodPrice ?? void 0);
      resetPaymentDetails();
      setSelectedPaymentMethod(selectedPaymentMethodType);
    },
    [paymentMethods, updatePspInfo, onPaymentMethodSelected, resetPaymentDetails]
  );
  React.useEffect(() => {
    if (paymentMethods.length && selectedPaymentMethod === "" && paymentMethodName.length) {
      handleChange(paymentMethodName);
    }
  }, [paymentMethodName, paymentMethods, selectedPaymentMethod]);
  if (!paymentMethodItems.length || loading) {
    return /* @__PURE__ */ React.createElement(Loader, null);
  }
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(
    PaymentMethodsUI,
    {
      handleChange,
      paymentMethodItems,
      selectedPaymentMethodType: selectedPaymentMethod
    }
  ), qrComponent);
};
export {
  PaymentMethodsUIContainer
};
//# sourceMappingURL=PaymentMethodsUIContainer.js.map
